module.exports = __webpack_public_path__ + "static/media/cn.6531afd1.svg";